import React from 'react'
import CustomLink from '@/shared/components/customLink'

type pagePropsType = {
	fow: {
		oBatter: {
			sFullName: string
			sShortName: string
			eTagStatus: string
			oSeo: {
				sSlug: string
			}
		}
		sOverDismissal: number
		nWicketNumber: number
		nScoreDismissal: number
	}
}

export default function FallWicketRow({ fow }: pagePropsType) {
	const player = fow?.oBatter
	const playerSlug = player?.oSeo?.sSlug
	return (
		<tr>
			<td>
				{fow?.oBatter?.eTagStatus === 'a' ? (
					playerSlug ? (
						<CustomLink
							href={`/${playerSlug}`}
							prefetch={false}>
							{fow?.oBatter?.sFullName || fow?.oBatter?.sShortName}
						</CustomLink>
					) : (
						fow?.oBatter?.sFullName || fow?.oBatter?.sShortName
					)
				) : (
					fow?.oBatter?.sFullName || fow?.oBatter?.sShortName
				)}
			</td>
			<td>
				{fow?.nScoreDismissal !== null || fow?.nScoreDismissal !== undefined ? fow?.nScoreDismissal : '--'}-
				{fow?.nWicketNumber !== null || fow?.nWicketNumber !== undefined ? fow?.nWicketNumber : '--'}
			</td>
			<td>{fow?.sOverDismissal !== null || fow?.sOverDismissal !== undefined ? fow?.sOverDismissal : '--'}</td>
		</tr>
	)
}
